import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
import '@/styles/portal.css';
import '@/styles/vuetify.css';
import '@fortawesome/fontawesome-pro/css/all.css';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/pro-solid-svg-icons';

library.add(fas);
Vue.use(Vuetify);

const opts = {
  theme: {
    options: { customProperties: true },
    disable: false,
    themes: {
      light: {
        primary: '#00b2b2',
        secondary: '#3F404D',
        accent: '#0cf9d6',
        error: '#d43535',
        info: '#2196F3',
        success: '#00c499',
        warning: '#de612b',
        selected: '#E4EFFA',
        text_primary: '#27263A',
        darkblue: '#222b47',
        backdrop: '#F2FDFF',
        primary_dark: '#00BCD4'
      },
      dark: {
        primary: '#00b2b2',
        secondary: '#3F404D',
        accent: '#0cf9d6',
        error: '#d43535',
        info: '#2196F3',
        success: '#00c499',
        warning: '#de612b',
        selected: '#E4EFFA',
        text_primary: '#FFF',
        darkblue: '#222b47',
        backdrop: '#000',
        primary_dark: '#00BCD4'
      }
    }
  },
  icons: {
    iconfont: ['fa'],
    values: {
      success: 'fas fa-circle-check',
      error: 'fas fa-circle-exclamation',
      info: 'fas fa-circle-info',
      warning: 'fas fa-circle-exclamation',
    },
  }
};

export default new Vuetify(opts);
